import {remCalc} from '_themeUtils'
import {tabsAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/react'

const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(tabsAnatomy.keys)

const baseStyle = definePartsStyle({
    tab: {
        // textTransform: 'uppercase',
        // letterSpacing: remCalc(3),
    },
})

const sizes = {
    sm: definePartsStyle({
        tablist: {
            textStyle: 'paragraphXs',
        },
        tab: {
            fontSize: 'inherit',
            px: 0,
            py: 'spacing.3',
        },
    }),
}

const variants = {
    line: definePartsStyle({
        tablist: {
            borderBottom: 0,
            gap: {base: 0, md: 'spacing.6'},
            pb: remCalc(2),
            justify: {base: 'space-evenly', md: 'flex-start'},
        },
        tab: {
            textStyle: 'paragraphXs',
            color: 'color.text.tab.default',
            borderBottom: `${remCalc(2)} solid`,
            borderBottomColor: 'color.border.tab.default',
            flex: {base: 1, md: 'auto'},
            _selected: {
                color: 'color.text.tab.active',
                borderBottomColor: 'color.border.tab.active',
                bg: 'none',
            },
            _active: {
                color: 'color.text.tab.active',
                borderBottomColor: 'color.border.tab.active',
                bg: 'none',
            },
        },
        tabpanel: {
            p: 0,
        },
    }),
    recommendations: definePartsStyle({
        tablist: {
            borderBottom: 0,
            gap: {base: 0, md: 'spacing.6'},
            pb: {base: 'spacing.6', md: remCalc(50)},
            justifyContent: {base: 'center', md: 'flex-start'},
        },
        tab: {
            textStyle: 'paragraphSm',
            pt: remCalc(14),
            pb: remCalc(14),
            pl: 0,
            pr: remCalc(5),
            borderBottom: '1px solid',
            borderBottomColor: 'color.text.grey.400',
            // flex: {base: 1, md: 'auto'},
            _selected: {
                color: 'color.text.tab.active',
                borderBottomColor: 'color.border.tab.active',
                bg: 'none',
            },
            _active: {
                color: 'color.text.tab.active',
                borderBottomColor: 'color.border.tab.active',
                bg: 'none',
            },
        },
        tabpanel: {
            p: 0,
        },
    }),
    sizeGuide: definePartsStyle({
        // Figma: tabs sit 40px apart on desktop (5655-4321 / 5655-4198). The tablist→content gap is
        // 20px in the Size Guide (5655-4198 / 5847-11290); the ProductInfo drawer, which needs a larger
        // ~36px gap (5655-4321 / 5847-11406), adds the extra space on its own content wrapper.
        tablist: {
            borderBottom: 0,
            gap: {base: 'spacing.6', md: 'spacing.10'},
            pb: 'spacing.5',
            justifyContent: {base: 'space-between', md: 'flex-start'},
            overflowX: 'auto',
            flexWrap: 'nowrap',
        },
        tab: {
            textStyle: 'paragraphSm',
            pt: remCalc(14),
            pb: remCalc(15),
            pl: 0,
            pr: remCalc(5),
            flexShrink: 0,
            whiteSpace: 'nowrap',
            borderBottom: '1px solid',
            borderBottomColor: 'color.text.grey.400',
            _selected: {
                color: 'color.text.tab.active',
                borderBottomColor: 'color.border.tab.active',
                bg: 'none',
            },
            _active: {
                color: 'color.text.tab.active',
                borderBottomColor: 'color.border.tab.active',
                bg: 'none',
            },
        },
        tabpanel: {
            p: 0,
        },
    }),
}

const tabs = {Tabs: defineMultiStyleConfig({baseStyle, sizes, variants})}

export default tabs
